import { React, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { AgentRegistration } from "../../../services/AgentRegistration";
import { useFormik } from "formik";
import CustomInput from "../../CustomInput/CustomInput";
import { useSelector, useDispatch } from "react-redux";
import { loginItemsSelector, setAgentSignupData } from "../../../redux/login";
import { setAgentSignupStepCount } from "../../../redux/login";
import { useTranslation } from "react-i18next";
import { ReactComponent as GoBackIcon } from "../../../assets/svg/arrow_back_icon.svg";
import { getAgentDetails } from "../../../../src/services/AgentServices";
import Loader from "../../loader/Loader";

const ReferredBy = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { agentSignUpData } = useSelector(loginItemsSelector);
  const storedSignupData = JSON.parse(
    localStorage.getItem("agent_signup_data") || "{}",
  );

  const [agentCode, setAgentCode] = useState(
    storedSignupData.agentCode || agentSignUpData?.items?.agentCode || "",
  );
  const [agentName, setAgentName] = useState(
    storedSignupData.agentName || agentSignUpData?.items?.agentName || "",
  );
  const [loading, setLoading] = useState(false);

  const handleLogin = async (values) => {
    const tempObj = { ...agentSignUpData?.items };
    const newObj = {
      ...tempObj,
      agentCode: agentCode,
      agentName: agentName,
    };
    dispatch(setAgentSignupData({ ...newObj }));
    localStorage.setItem("agent_signup_data", JSON.stringify(newObj));
    try {
      let formData = new FormData(); //formdata object
      formData.append("first_name", agentSignUpData?.items.first_name);
      formData.append("middle_name", agentSignUpData?.items.middle_name);
      formData.append("last_name", agentSignUpData?.items.last_name);
      formData.append("email", agentSignUpData?.items.email);
      formData.append("contact_number", agentSignUpData?.items.contact_number);
      formData.append("password", agentSignUpData?.items.password);
      formData.append("user_type", 2);
      formData.append("address", agentSignUpData?.items.address);
      formData.append("city", agentSignUpData?.items.city);
      formData.append("state", agentSignUpData?.items.state);
      formData.append("country", agentSignUpData?.items.country);
      formData.append("bank_name", agentSignUpData?.items.bank_name);
      formData.append("neighborhood", agentSignUpData?.items.neighborhood);
      formData.append("account_number", agentSignUpData?.items.account_number);
      formData.append(
        "tax_registration",
        agentSignUpData?.items.tax_registration
      );
      // formData.append("postal_code", agentSignUpData?.items.postal_code);
      formData.append("id_proof", agentSignUpData?.items.uploadedIdProof);
      formData.append(
        "address_proof",
        agentSignUpData?.items.uploadedAddressProof
      );
      formData.append("tax_proof", agentSignUpData?.items.uploadedTaxProof);
      // if(agentCode.trim()){
      // formData.append("agent_code", agentCode);
      // }
      if (agentCode.trim() && agentName.trim()) {
        formData.append("agent_code", agentCode);
      }


      // formData.append("agent_name", values?.agent_name);
      const extraConfig = {
        headers: { "content-type": "multipart/form-data" },
      };
      setLoading(true);
      const response = await AgentRegistration(formData, extraConfig);
      setLoading(false);
      if (response) {
        setLoading(false);
        dispatch(setAgentSignupStepCount(4));
      }
    } catch (e) {
      setLoading(false);
      console.log(e, "err");
    }
  };

  const handleAgentCodeChange = async (e) => {
    const code = e.target.value.trim();
    setAgentCode(code);
    formik.setFieldValue("agent_code", code);

    if (code.length === 6) {
      const data = await getAgentDetails(code);
      if (data) {
        const fullName = `${data.first_name} ${data.middle_name || ""} ${data.last_name}`.trim();
        setAgentName(fullName);
        formik.setFieldValue("agent_name", fullName);
      } else {
        setAgentCode("");
        setAgentName("");
        formik.setFieldValue("agent_code", "");
        formik.setFieldValue("agent_name", "");
      }
    } else {
      setAgentName("");
      formik.setFieldValue("agent_name", "");
    }
  };



  const formik = useFormik({
    initialValues: {
      first_name: "",
      middle_name: "",
      last_name: "",
      contact_number: "",
      email: "",
      password: "",
      confirm_password: "",
      address: "",
      city: "",
      state: "",
      country: "",
      bank_name: "",
      account_number: "",
      tax_registration: "",
      agent_code: storedSignupData.agentCode || agentSignUpData?.items?.agentCode || "",
      agent_name: storedSignupData.agentName || agentSignUpData?.items?.agentName || "",
      user_type: 2,
    },
    enableReinitialize: true,
    onSubmit: handleLogin,
  });

  return (
    <>
      {loading && <Loader />}
      <Box sx={{ px: 5, pt: 3, pb: 4, background: '#FFFFFF' }}>
        <Button
          onClick={() => dispatch(setAgentSignupStepCount(2))}
          sx={{
            minWidth: 'auto',
            p: 1,
            mb: 2,
            borderRadius: '50%',
            color: '#64748B',
            '&:hover': { background: '#F1F5F9', color: '#0085FD' }
          }}
        >
          <GoBackIcon style={{ width: 24, height: 24 }} />
        </Button>

        <form onSubmit={formik.handleSubmit} noValidate>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "1.75rem",
              color: "#1E293B",
              fontFamily: "Outfit, sans-serif",
              textAlign: 'center',
              width: '100%',
              mb: 1
            }}
          >
            {t("AgentRegistration.Agent_Registration")}
          </Typography>
          <Typography
            sx={{
              fontSize: "0.875rem",
              color: "#64748B",
              textAlign: "center",
              mb: 4
            }}
          >
            {t("AgentRegistration.Referred_by")}
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 5 }}>
            <CustomInput
              variant="outlined"
              fullWidth
              label={t("AgentRegistration.Agent_Code")}
              placeholder={t("AgentRegistration.Agent_Code")}
              InputLabelProps={{ shrink: true }}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
              onChange={handleAgentCodeChange}
              value={agentCode}
            />

            <CustomInput
              variant="outlined"
              fullWidth
              label={t("AgentRegistration.Agent_Name")}
              placeholder={t("AgentRegistration.Agent_Name")}
              InputLabelProps={{ shrink: true }}
              sx={{
                '& .MuiOutlinedInput-root': { borderRadius: '10px', bgcolor: '#F1F5F9' },
                '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: '#1E293B', fontWeight: 500 }
              }}
              disabled
              value={agentName}
              readOnly
            />
          </Box>

          <Button
            type="submit"
            variant="contained"
            disableElevation
            fullWidth
            sx={{
              bgcolor: "#0085FD",
              color: "white",
              py: 1.5,
              borderRadius: "10px",
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 600,
              mb: 2,
              "&:hover": { bgcolor: "#0072DB" }
            }}
          >
            Save & Next
          </Button>
        </form>
      </Box>
    </>
  );
};
export default ReferredBy;
